import { useMutation } from 'react-query';
import { removeTeamMember } from 'api/services/team';

const useTeamMembersDelete = (
  memberId,
  memberName,
  refetchMembers,
  showSuccessNotification,
  showErrorNotification,
) => {
  const { mutate } = useMutation(
    async () => {
      if (memberId) {
        await removeTeamMember(memberId);
      }
    },
    {
      onSuccess: async () => {
        showSuccessNotification(`${memberName} removed from the team successfully.`);
        await refetchMembers();
      },
      onError: () => {
        showErrorNotification(`An error occurred while removing ${memberName} from the team.`);
      },
    },
  );
  return { mutate };
};

export default useTeamMembersDelete;
